export default __webpack_public_path__ + "static/media/copperNickle.b65f97a9.jpg";